<template>
  <div class="p-4 border rounded-lg mb-3">
    <div class="flex items-center justify-between">
      <div>
        <p class="font-semibold text-gray-700" :class="[ _bundle.value ? 'text-gray-700 dark:text-gray-200' : 'text-gray-500 dark:text-gray-400']">
          {{ _bundle.name }}
        </p>
        <p class="text-xs text-gray-500 dark:text-gray-400">
          {{ _bundle.information }}
        </p>
      </div>

      <div>
        <toggle-field v-model="_bundle.value" />
      </div>
    </div>

    <div v-if="_bundle.value && _bundle.options" class="border-t mt-3 pt-3">
      <bundle-option v-for="option in _bundle.options" :key="option.name" v-model="option.value" :option="option" class="mb-3" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import BundleOption from '@/components/roles/elements/BundleOption.vue'

import {
  ToggleField,
} from '@/components/fields'

interface Props {
  bundle: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:bundle', value: Record<string, any>): void
}>()

const _bundle = computed({
  get () {
    return props.bundle
  },
  set (value) {
    emit('update:bundle', value)
  },
})
</script>
